/**
 * @fileoverview Custom logic for overriding the default quick cart behaviours
 */

/**
 * Repository of AJAX cart API requests.
 *
 * See https://shopify.dev/docs/themes/ajax-api/reference/cart
 * for more information about each endpoints.
 */
(function (cartService) {
  cartService.addItemToCart = async function (
    variant_id,
    qty,
    deliveryDate,
    handle,
    customProperties = {}
  ) {
    const productData = {
      id: variant_id,
      quantity: qty,
      properties: deliveryDate
        ? {
            "Delivery Date": deliveryDate,
            _handle: handle,
            ...customProperties,
          }
        : { _handle: handle, ...customProperties },
    };

    await $.post("/cart/add.json", productData, null, "json");
  };

  cartService.getCartInfo = async function () {
    let cartInfo = await $.get("/cart.json", null, null, "json");
    // Getting quantity of product options and product fee
    // let specialProductsQuantity = cartInfo.items.filter(
    //   item => [variant_product_options, variant_product_fee, variant_shipping_item_fee].includes(item.id)
    // ).map(item => item.quantity).reduce((prev, curr) => prev + curr, 0);
    // cartInfo.item_count -= specialProductsQuantity;
    return cartInfo;
  };
  //Used on QuickCart Update Quantity Product (+) and (-)
  cartService.updateLineItemQuantity = async function (
    line_index,
    new_quantity
  ) {
    // items index start with 1 on update.json

    let cartInfo = [];

    jQuery.ajax({
      type: "GET",
      url: "/cart.json",
      data: null,
      async: false,
      dataType: "json",
      success: function (data) {
        cartInfo = data;
      },
    });
   
    let associativeIDOwner =
      cartInfo.items[line_index - 1].properties.associativeID;

    //console.log("updateLineItemQuantity ", "line index", line_index, "qty", new_quantity, "cart info ", cartInfo.items);

    let handlesKeepQty = window.extra_products_js_handles.filter(
      (x) =>
        x != "saturday-delivery" &&
        x != "shipping-surcharge" &&
        x != "product-options"
    );

    let productOwner = cartInfo.items.filter(
      (item) =>
        item.properties.associativeID === associativeIDOwner &&
        !window.extra_products_js_handles.includes(item.handle)
    )[0];
    let productOwnerProps = productOwner.properties;

    /*update qty cases:  saturday delivery, all extra products when qty ==0, the owner product  */
    let updatedQtyItems = cartInfo.items.map((x) => {
      if (
        (x.properties.associativeID === associativeIDOwner &&
          !handlesKeepQty.includes(x.handle)) ||
        (x.properties.associativeID === associativeIDOwner &&
          new_quantity === 0) ||
        (x.properties.associativeID === associativeIDOwner &&
          new_quantity > 0 &&
          !handlesKeepQty.includes(x.handle))
      ) {
        switch (x.handle) {
          case "product-options":
            productOwnerProps._productOptionsSurcharge =
              parseFloat(x.properties.Amount) * new_quantity;
            return parseInt(
              new_quantity * parseInt(productOwnerProps._newQtyProOptions)
            );
            break;
          case "shipping-surcharge":
            productOwnerProps._productShippingItemFeeTotal =
              parseFloat(x.properties.Amount) * new_quantity;
            break;
        }
        return new_quantity;
      } else {
        switch (x.handle) {
          case "product-fee":
            productOwnerProps._productItemFeeTotal =
              parseFloat(x.properties["Fee Value"]) * new_quantity;
            break;
        }
        return x.quantity;
      }
    });
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.json",
      data: {
        line: cartInfo.items.indexOf(productOwner) + 1,
        properties: productOwnerProps,
      },
      async: false,
      dataType: "json",
    });
    return await $.post(
      "/cart/update.json",
      { updates: updatedQtyItems },
      null,
      "json"
    );
  };
  //Used on CartPage to Update Quantity Product (+) and (-)
  cartService.updateItemQuantitySync = function (line_index, new_quantity) {
    // items index start with 1 on update.json

    let cartInfo = [];
    jQuery.ajax({
      type: "GET",
      url: "/cart.json",
      data: null,
      async: false,
      dataType: "json",
      success: updateCartInfo,
    });

    function updateCartInfo(data) {
      cartInfo = data;
    }
    let associativeIDOwner =
      cartInfo.items[line_index - 1].properties.associativeID;


    let handlesKeepQty = window.extra_products_js_handles.filter(
      (x) =>
        x != "saturday-delivery" &&
        x != "shipping-surcharge" &&
        x != "product-options"
    );

    let productOwner = cartInfo.items.filter(
      (item) =>
        item.properties.associativeID === associativeIDOwner &&
        !window.extra_products_js_handles.includes(item.handle)
    )[0];
    let productOwnerProps = productOwner.properties;

    /*update qty cases:  saturday delivery, all extra products when qty ==0, the owner product  */
    let updatedQtyItems = cartInfo.items.map((x) => {
      if (
        (x.properties.associativeID === associativeIDOwner &&
          !handlesKeepQty.includes(x.handle)) ||
        (x.properties.associativeID === associativeIDOwner &&
          new_quantity === 0) ||
        (x.properties.associativeID === associativeIDOwner &&
          new_quantity > 0 &&
          !handlesKeepQty.includes(x.handle))
      ) {
        switch (x.handle) {
          case "shipping-surcharge":
            productOwnerProps._productShippingItemFeeTotal =
              parseFloat(x.properties.Amount) * new_quantity;
            break;
          case "product-options":
            productOwnerProps._productOptionsSurcharge =
              parseFloat(x.properties.Amount) * new_quantity;
            return parseInt(
              new_quantity * parseInt(productOwnerProps._newQtyProOptions)
            );
            break;
        }
        return new_quantity;
      } else {
        if (x.handle === "product-fee") {
          productOwnerProps._productItemFeeTotal =
            parseFloat(x.properties["Fee Value"]) * new_quantity;
        }
        return x.quantity;
      }
    });

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.json",
      data: {
        line: cartInfo.items.indexOf(productOwner) + 1,
        properties: productOwnerProps,
      },
      async: false,
      dataType: "json",
    });
    return jQuery.ajax({
      type: "POST",
      url: "/cart/update.json",
      data: { updates: updatedQtyItems },
      async: false,
      dataType: "json",
    });
  };

})((window.cartService = window.cartService || {}));

/**
 * Custom methods that override the original quick cart behaviours.
 *
 * The original quick cart provided by the IRA theme does not support custom
 * fields on the product. Also, updating quantity in the quick cart is not
 * compatible with custom fields.
 */
(function (quickCart) {
/* The above code is adding a class to the quick cart div and then displaying the cart. */
  quickCart.displayCart = function (isEmpty) {
    $(".quick-cart")
      .addClass("active")
      .delay(200)
      .queue(() => $(".quick-cart").addClass("visible").dequeue());
    displayEmptyOrFooter(isEmpty);
  };

  quickCart.updateCart = ({
    subtotal,
    itemCount,
    items,
    updateHeader = true,
    openCart = false,
  }) => {
    //console.log( "update all Cart"," original itemcount",itemCount,  "items" , items);
    let newItemCount = items
      .filter((x) => !window.extra_products_js_handles.includes(x.handle))
      .map((item) => item.quantity)
      .reduce((a, c) => {
        return a + c;
      }, 0);
    //console.log( "update all Cart","new itemcount",newItemCount );
    console.log("cart", items);
    quickCart.cleanEventDate(items,'quickCart-template');     
    updateQuickCartItems(newItemCount);
    const isEmpty = itemCount === 0;
    updateSubtotal(subtotal);
    updateCartItems(items);
    updateHeader && updateHeaderCart(newItemCount);
    openCart ? quickCart.displayCart(isEmpty) : displayEmptyOrFooter(isEmpty);
};

  /**
   * Format price value from endpoints by adding a decimal point
   * @param {number} val
   * @return {string} formatted price value
   */
   quickCart.convertPrice = (val)=> {
    const price = val.toString();
    if (price === "0") return "$0.00";
    const position = price.length - 2;
    return `$${[price.slice(0, position), ".", price.slice(position)].join(
      ""
    )}`;
  };

  quickCart.cleanEventDate=(items,locatedID)=>{
    if(items.length==0){
      eventDateUtils.handleLocalStorage("remove", "event-date");
      eventDateUtils.updateUIDate(true,'',locatedID);
    }
  };

/* Checking if the cart is empty or not and displaying the appropriate content. */
  const displayEmptyOrFooter = function (isEmpty) {
    if (isEmpty) {
      $(".quick_cart__empty").addClass("visible");
      $(".quick-cart__footer").removeClass("visible");
      $(".quick-cart__header_container").removeClass("visible");
      $(".quick-cart-flowerKits").removeClass("visible");
    } else {
      $(".quick_cart__empty").removeClass("visible");
      $(".quick-cart__footer").addClass("visible");
      $(".quick-cart__header_container").addClass("visible");
      $(".quick-cart-flowerKits").addClass("visible");
    }
  };

  var kitInCart;
  var productTypes = [];

  const updateCartItems = function (cartItems) {
    productTypes = [];

    const itemContainer = $("div[data-items-custom]");
    itemContainer.empty();
    let product_associative_id = "";
    cartItems.forEach((item, id) => {
      const itemData = {
        variantId: item.variant_id,
        url: item.url,
        key:item.key,
        image: item.image,
        title: item.product_title,
        linePrice: item.final_price,
        finalLinePrice: item.final_line_price,
        optionsWithValues: item.options_with_values,
        properties: item.properties,
        quantity: item.quantity,
        line: id + 1,
      };

      if (!productTypes.includes(item.product_type)) {
        productTypes.push(item.product_type);
      }

      if (product_associative_id != item.properties.associativeID && id != 0) {
        itemContainer.append("<hr class='quick-cart-hr'/>");
      }

      if (window.extra_products_js_handles.includes(item.handle)) {
        // console.log(" total ", itemData.linePrice, quickCart.convertPrice(itemData.linePrice), itemData.quantity);
        itemContainer.append(renderExtraFeeItem(itemData));
      } else {
        itemContainer.append(renderCartItem(itemData));
      }

      product_associative_id = item.properties.associativeID;
    });

    kitInCart = productTypes.includes("Kits");

    var containerMediaQuery = window.matchMedia("(min-width: 60em)");
    var smallerContainerMediaQuery = window.matchMedia("(max-width: 59em");

    if (kitInCart) {
      if (smallerContainerMediaQuery.matches) {
        document.getElementById("quick-cart__items").style.maxHeight = "fit-content";
      }
    } else {
      if (smallerContainerMediaQuery.matches) {
        document.getElementById("quick-cart__items").style.maxHeight = "fit-content";
      }
    }
  };

/**
 * *Update the quantity of items in the quick cart by adding or subtracting the quantity of the item.*
 * @param newQuantity - The new quantity of the item in the cart.
 */
  const updateQuickCartItems=(newQuantity)=>{
    $("span[data-quick-cart-counter]").text(newQuantity);
  }
  
  const updateSubtotal = (newSubtotal) =>
    $("span[data-subtotal]").text(quickCart.convertPrice(newSubtotal));

  /** Update item count in header cart element and animate the indicator */
  const updateHeaderCart = async function (newQuantity) {
    const cartIndicator = $("div[data-js-cart-indicator]");
    if (newQuantity === 0) {
      cartIndicator.removeClass("visible");
    } else {
      $("span[data-js-cart-count]").text(newQuantity);
    }
  };

  const renderExtraFeeItem = ({
    variantId,
    url,
    image,
    title,
    linePrice,
    finalLinePrice,
    optionsWithValues,
    properties,
    quantity,
  }) => ``;

  //Uncomment to display special product sin quick cart. eg: Product Options
  /*
    const renderExtraFeeItem = ({
      variantId,
      url,
      image,
      title,
      linePrice,
      finalLinePrice,
      optionsWithValues,
      properties,
      quantity,
    }) => `<div class="quick-cart__item ff-body fs-body-base" data-id="${variantId}">
      <div class="quick-cart__item-left">    
        <div class="quick-cart__image" style="height:50%; display: flex;justify-content: center; background-color: inherit;"><img class="image__img ls-is-cached lazyloaded" data-src="${image}" src="${image}" style="width: auto; height: 100%;"  ></div>
        
        <div class="quick-cart__control" style="height: 22px; margin-top: 4px !important;">
          <div class="quick-cart__qty ff-body fs-body-base ta-c" data-qty="" style="text-align: center; margin: 0 auto;">${quantity}</div>
        </div>
      </div>
      <div class="quick-cart__item-right">
        <h4>${title} of ${properties.associativeName}</h4>
        <div>
          ${convertPrice(finalLinePrice)}      
        </div>
      </div>  
    </div>`;
  */
    const renderCartItem = ({
      variantId,
      url,
      key,
      image,
      title,
      linePrice,
      optionsWithValues,
      properties,
      quantity,
      line,
    }) => {
      let isMobile=(/Mobi/.test(navigator.userAgent));
      let realWidth=(document.documentElement.scrollWidth<1024?true:false);
      return (
`
  <div>
  <h4 class="quick-cart-product-title" style="display:${isMobile?'block':'none'}">PRODUCT</h4>
    <div class="cart__item_qkcart">
`
    +
        //Image
        `
      <div class="cart__item-image-quick-cart borders">
       <div class="image image--responsive " style="padding-top: 100.0%">
        <a href="${url}">
          <img 
          class="image__img lazyautosizes lazyloaded" 
          data-src="${image}" 
          src="${image}"
          alt="${title}"
          >
            </a> 
        </div>
       </div>
        ` +
        //Product Description
        `
    <div class="cart__item-main-quick-cart">
      <div class="cart__item-details">
        <a
        href="${url}"
        class="cart__item-title ff-heading fs-body-base">
        ${title}
        </a>
        <div class="cart__item-price fs-body-base">
          ${quickCart.convertPrice(linePrice)}
        </div>
        <div class="cart__item-properties fs-body-base">
          ${renderOptionsWithValues(optionsWithValues)}
        </div>
        <div class="product_options_container cart__item-properties fs-body-base">
          ${renderProperties(properties)}
        </div>
       </div>
      `+
      //Quantity Product
      `
      <div style="display:${isMobile&realWidth?'none':'grid'}"class="cart__item-quantity-quick-cart">
        <div class="cart__item-qty-selector">
         <a id="decrementProduct_${key}" class="cart__item-button" href="#" data-change="decrement" onclick="quickCart.decreaseQuantityQuickCart( ${line},'${key}', ${quantity}); ">
          <span class="icon " id="">
           <svg width="100%" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path d="M19 13H5v-2h14v2z" fill="currentColor"></path>
           </svg>
          </span>
         </a>
         <input type="number" name="updates[]" id="product_${key}" value="${quantity}" min="0" aria-label="translation missing: en.cart.general.quantity" line="${line}">
         <a id="incrementProduct_${key}" class="cart__item-button" href="#" data-change="increment" onclick="quickCart.increaseQuantityQuickCart( ${line},'${key}', ${quantity});">
          <span class="icon " id="">
            <svg width="100%" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"></path>
            </svg>
          </span>
         </a>
        </div>
       <a class="cart-item__remove" href="#" onclick="quickCart.removeQuantityQuickCart(${line},'${key}',0)">Remove</a>
      </div>
    </div>
      `+
      //Total of Product
        `
      <div class="cart__item-total fs-body-base" id="linePrice_${line}">  
          ${quickCart.convertPrice(linePrice*quantity)} 
      </div>
        `
      +
    `</div>`
    + // Quantity for Mobile Only
    `
    <div id="mobile-cart-item-quantity-quick-cart" style="display:${isMobile&realWidth?'flex':'none'}" class="cart__item-quantity-quick-cart-2">
      <div class="cart__item-qty-selector">
       <a id="decrementProduct_${key}" class="cart__item-button" href="#" data-change="decrement" onclick="quickCart.decreaseQuantityQuickCart( ${line},'${key}', ${quantity}); ">
        <span class="icon " id="">
         <svg width="100%" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none"></path>
          <path d="M19 13H5v-2h14v2z" fill="currentColor"></path>
         </svg>
        </span>
       </a>
       <input type="number" name="updates[]" id="product_${key}" value="${quantity}" min="0" aria-label="translation missing: en.cart.general.quantity" line="${line}">
       <a id="incrementProduct_${key}" class="cart__item-button" href="#" data-change="increment" onclick="quickCart.increaseQuantityQuickCart( ${line},'${key}', ${quantity});">
        <span class="icon " id="">
          <svg width="100%" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none"></path><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor"></path>
          </svg>
        </span>
       </a>
      </div>
     <a class="cart-item__remove" href="#" onclick="quickCart.removeQuantityQuickCart(${line},'${key}',0)">Remove</a>
    </div> 
  </div> `
      );
    };
 
  const renderOptionsWithValues = function (optionsWithValues) {
    let options = "";
    if (!optionsWithValues || optionsWithValues.length === 0) return options;
    optionsWithValues.forEach((obj) => {
      if (obj["name"] !== "Estilo") {
        options += `<div>${obj["name"]}: ${obj["value"]}</div>`;
      }
    });
    return options;
  };

  const renderProperties = function (properties) {
    let propertyInfo = "";
    if (!properties) return propertyInfo;
    const propertyArray = Object.entries(properties);
    if (propertyArray.length === 0) return propertyInfo;
    propertyArray
      .filter(([key]) => key[0] !== "_")
      .forEach(([key, value]) => {
        switch (key) {
          case "Amount":
            break;
          case "associativeID":
            break;
          case "associativeName":
            break;
          case "ProductOptionsText":
            propertyInfo += `<div class="cart-prod-opt">Product Options:<br>`;
            for(var i = 0; i < value.length; i++){
              let text = value[i];
              let resPos = text.indexOf(":");
              propertyInfo += text.substr(resPos+1) + `<br>`;
            }         
            propertyInfo += `</div>`;   
            break;
          case "Product Options":
            propertyInfo += `<div>${key}: ` + value[0] + `....</div>`;
            break;
          default:
            propertyInfo += `<div>${key}: ${value}</div>`;
            break;
        }
      });
    return propertyInfo;
  };

/* The above code is increasing the quantity of the item in the cart by 1. */
  quickCart.increaseQuantityQuickCart = async (idx,key, quantity) => {
    const {
      items: cartItems,
      item_count: cartItemCount,
      items_subtotal_price: subtotal,
    } = await cartService.updateLineItemQuantity(idx , quantity + 1);
    quickCart.updateCart({
      subtotal: subtotal,
      items: cartItems,
      itemCount: cartItemCount,
    });
  };

/* The above code is a function that will decrease the quantity of a specific item in the cart. */
  quickCart.decreaseQuantityQuickCart = async (idx,key,quantity) => {
    const {
      items: cartItems,
      item_count: cartItemCount,
      items_subtotal_price: subtotal,
    } = await cartService.updateLineItemQuantity(idx , quantity - 1);
    quickCart.updateCart({
      subtotal: subtotal,
      items: cartItems,
      itemCount: cartItemCount,
    });      
  };

/* The above code is removing a quantity from the cart. */
  quickCart.removeQuantityQuickCart = async (idx,key,quantity) => {
    const {
      items: cartItems,
      item_count: cartItemCount,
      items_subtotal_price: subtotal,
    } = await cartService.updateLineItemQuantity(idx ,quantity);
    quickCart.updateCart({
      subtotal: subtotal,
      items: cartItems,
      itemCount: cartItemCount,
    });      
  };


/* The above code is adding a flower kit to the cart. */
  quickCart.addFlowerKitToCart = async(variant_id, qty, handle,productName)=>{
    let dates=[]
    let cartItems = [];
    let earlyDeliveryDate="";
    let associativeID=Math.random().toString(36).substr(2, 9);
  
    jQuery.ajax({ type: 'GET', url: '/cart.json', data: null, async: false, dataType: 'json', success: function(data) { cartItems = data.items;}  });   
    cartItems.map((item) => {
        let itemDate=item.properties['Delivery Date'];
        if(itemDate){
          dates.push(new Date(itemDate))
        }
    });
    
      let minDate=new Date(Math.min.apply(null,dates));
      earlyDeliveryDate=((minDate.getMonth() + 1)+"/"+minDate.getDate()+"/"+minDate.getFullYear());

        await cartService.addItemToCart(
          variant_id,
          qty,
          earlyDeliveryDate,
          handle,
          {
            _handle: handle,
            'associativeID':associativeID,
            'associativeName':productName,
            'Delivery Date':earlyDeliveryDate,
          }
        );
  }

/* Adding a class to the quick cart overlay and the quick cart container. */
  quickCart.loadQuickCartUI= () =>{
    //disable on mobile  
    // modify top and height dynamically only on desktop 
    if (!(/Mobi/.test(navigator.userAgent))) {
    let shopifyAnnouncementBar=parseFloat(document.getElementById('shopify-section-announcement-bar').offsetHeight);
    let shopifySectionHeader=parseFloat(document.getElementById('shopify-section-header').offsetHeight);
    let stickyProductFormBottom=
      document.getElementById('sticky-product-form')?
        parseFloat(document.getElementById('sticky-product-form').offsetHeight)
        :0;
     if(window.scrollY==0){
        $('.quick-cart__overlay').attr('style',
         `top: ${shopifyAnnouncementBar+shopifySectionHeader}px !important;
          height:calc(100% - (${shopifyAnnouncementBar+shopifySectionHeader}px))!important;`);
        $('.quick-cart').attr('style', `top: ${shopifyAnnouncementBar+shopifySectionHeader}px !important;
          height:calc(100% - (${shopifyAnnouncementBar+shopifySectionHeader}px))!important;`);
      }else{
        $('.quick-cart__overlay').attr('style', `top: ${shopifySectionHeader}px !important;
        height:calc(100% - (${shopifySectionHeader}px))!important;`);
        $('.quick-cart').attr('style', `top: ${shopifySectionHeader}px !important;
        height:calc(100% - (${shopifySectionHeader}px))!important;`);

        if($('#sticky-product-form').hasClass('spf visible')){
          $('.quick-cart__overlay').attr('style',
          ` top: ${shopifySectionHeader}px !important; 
            height:calc(100% - (${shopifySectionHeader+stickyProductFormBottom}px))!important;`
          );
          $('.quick-cart').attr('style',
          ` top: ${shopifySectionHeader}px !important; 
            height:calc(100% - (${shopifySectionHeader+stickyProductFormBottom}px))!important;`
          );
        }
      }
    }
  }
})((window.quickCart = window.quickCart || {}));
